import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { adminServices } from "../services/AdminServices";

const colonies = [
  { code: "NBP-MAX", label: "NBP-MAX: NBP Maxium" }
];

const getUrlByPageId = pageId => {
  const pageUrls = {
    1: "/dashboard",
    2: "/pdl-management",
    3: "/pdl-transactions",
    4: "padala-reports",
    5: "/kiosk-reports",
    6: "/void-transactions",
    7: "/floating-padala-reports",
    8: "/reprocess",
    9: "/load-money",
    10: "/load-merchant",
    11: "fund-transfer",
    12: "/inventory",
    13: "/merchant",
    14: "/merchant/add",
    15: "/merchant/edit",
    16: "/merchant-padala-reports",
    17: "/pos-sales-report",
    18: "/icarus-web",
    19: "/kiosk-status-reports",
    20: "/kiosk-add",
    21: "/kiosk-edit",
    22: "/pos-status-reports",
    23: "/ipx-transactions",
    24: "/cashout-requests",
    25: "/merchant-transactions"
  };
  return pageUrls[pageId] || "/dashboard";
};

const ColonySelectionPage = () => {
  const navigate = useNavigate();
  const [selectedColony, setSelectedColony] = useState(colonies[0].code);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!localStorage.getItem("appToken")) {
      navigate("/");
    }
  }, [navigate]);

  const handleContinue = async () => {
    setLoading(true);
    setError("");

    try {
      localStorage.setItem("selectedColony", selectedColony);

      const token = localStorage.getItem("appToken");
      const decoded = jwtDecode(token);
      const role = decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
      localStorage.setItem("currentRole", role);

      const response = await adminServices.storeProcedure2("getRolePages", { role_id: role });
      const pageIds = response.data.map(item => item.pageId);
      localStorage.setItem("pages", JSON.stringify(pageIds));

      const targetUrl = pageIds.length > 0 ? getUrlByPageId(pageIds[0]) : "/dashboard";
      navigate(targetUrl);
    } catch (err) {
      console.error("Failed to load role pages:", err);
      setError("Unable to continue. Please try again.");
      setLoading(false);
    }
  };

  return (
    <div className="mainContainer">
      <div className="loginPageContainer">
        <div className="loginPartition2">
          <div className="rightPart">
            <div>
              <p className="xl medium">Select Colony</p>
              <p className="r light">Choose the colony you want to manage.</p>
              <div style={{ height: "25px" }}></div>

              <div className="loginFields regular">
                <p>Colony</p>
                <select
                  className="m"
                  value={selectedColony}
                  onChange={e => setSelectedColony(e.target.value)}
                  style={{ width: "100%", padding: "10px" }}
                >
                  {colonies.map(colony => (
                    <option key={colony.code} value={colony.code}>
                      {colony.label}
                    </option>
                  ))}
                </select>
              </div>

              <div
                className="flexRow"
                style={{ color: "#FF0000", marginBottom: 15, justifyContent: "center" }}
              >
                {error}
              </div>

              <div
                className="flexRow"
                style={{ color: "green", marginBottom: 15, justifyContent: "center" }}
              >
                {loading ? "Loading, please wait..." : ""}
              </div>

              <div style={{ height: "20px" }}></div>
              <div className="loginButton">
                <button
                  type="button"
                  onClick={handleContinue}
                  disabled={loading}
                  className="btn btn-transparent btn-lg text-white"
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ColonySelectionPage;
